import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
const AuthCallback = () => {
  const navigate = useNavigate();
  const { hash } = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = new URLSearchParams(hash.replace("#", "")).get("session_id");
    if (!sessionId) { navigate("/admin", { replace: true }); return; }
    axios
      .post(`${API}/auth/session`, { session_id: sessionId })
      .then((res) => navigate("/admin", { replace: true, state: { user: res.data.user } }))
      .catch(() => navigate("/admin", { replace: true, state: { authError: true } }));
  }, [hash, navigate]);

  return (
    <div className="flex min-h-[70vh] items-center justify-center gap-3 font-mono-s text-xs uppercase tracking-[0.3em] text-[#A3ACBB]" data-testid="auth-callback">
      <Loader2 size={16} className="animate-spin text-[#C81D25]" /> Signing you in
    </div>
  );
};

export default AuthCallback;
